import type { CompanyInventoryRepository } from "../../../domain/repositories/company/company-inventory-repository";
import type {
  MaterialInventoryDto,
  InventoryRequest,
  InventoryLogPageResponse,
} from "../../../domain/types/company/company-product-system";
import {
  MaterialInventoryDtoSchema,
  InventoryLogPageResponseSchema,
} from "../../../domain/types/company/company-product-system";
import { companyProductSystemApiService } from "../../api/company/company-product-system-api-service";

export class CompanyInventoryRepositoryImpl implements CompanyInventoryRepository {
  async getAllInventory(companyId: number, type?: string): Promise<MaterialInventoryDto[]> {
    const response = await companyProductSystemApiService.getAllInventory(companyId, type);
    if (response.data) {
      return response.data.map((item) => MaterialInventoryDtoSchema.parse(item));
    }
    throw new Error(response.errorMsg || "재고 목록을 불러오지 못했습니다.");
  }

  async getInventory(companyId: number, materialId: number): Promise<MaterialInventoryDto> {
    const response = await companyProductSystemApiService.getInventory(companyId, materialId);
    if (response.data) {
      return MaterialInventoryDtoSchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "재고 정보를 불러오지 못했습니다.");
  }

  async receive(
    companyId: number,
    materialId: number,
    request: InventoryRequest,
  ): Promise<MaterialInventoryDto> {
    const response = await companyProductSystemApiService.receiveInventory(
      companyId,
      materialId,
      request,
    );
    if (response.data) {
      return MaterialInventoryDtoSchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "입고 처리에 실패했습니다.");
  }

  async deduct(
    companyId: number,
    materialId: number,
    request: InventoryRequest,
  ): Promise<MaterialInventoryDto> {
    const response = await companyProductSystemApiService.deductInventory(
      companyId,
      materialId,
      request,
    );
    if (response.data) {
      return MaterialInventoryDtoSchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "차감 처리에 실패했습니다.");
  }

  async returnStock(
    companyId: number,
    materialId: number,
    request: InventoryRequest,
  ): Promise<MaterialInventoryDto> {
    const response = await companyProductSystemApiService.returnInventory(
      companyId,
      materialId,
      request,
    );
    if (response.data) {
      return MaterialInventoryDtoSchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "반품 처리에 실패했습니다.");
  }

  async getLogs(
    companyId: number,
    materialId: number,
    page = 0,
    size = 20,
  ): Promise<InventoryLogPageResponse> {
    const response = await companyProductSystemApiService.getInventoryLogs(
      companyId,
      materialId,
      page,
      size,
    );
    if (response.data) {
      return InventoryLogPageResponseSchema.parse(response.data);
    }
    throw new Error(response.errorMsg || "재고 이력을 불러오지 못했습니다.");
  }
}
